import "./Panels.css"
import { images } from '../../shared/assets';
import { useTranslation } from 'react-i18next';


const IntroductionPanel: React.FC = () => {
  const { t } = useTranslation();

  const imgMapOverlay = images.atacamaFigma.offers.offer3Image;

  return (
    <div className="intropanel">
      {/* Text Content */}
      <div className="intropanel__text">
        <div className="intropanel__heading">
          {t('pages/home:carousel.intro.title')}
        </div>
        <div className="intropanel__description">
          {t('pages/home:carousel.intro.description')}
        </div>
      </div>

      {/* Map with Awasi Atacama marker */}
      <div className="intropanel__container">
        <picture>
          <img
            src={imgMapOverlay}
            alt="Map with Awasi Atacama marker"
          />
        </picture>
      </div>
    </div>
  );
};

export default IntroductionPanel;